import { useState } from 'react';
import { PanelGroup, Panel, Placeholder, IconButton } from 'rsuite';
import { Icon } from '@rsuite/icons';

import BasicButton from '../../../components/basicButton/basicButton';
import BasicNumberInput from '../../../components/basicNumberInput/basicNumberInput';
import BasicRadioGroup from '../../../components/basicRadioGroup/basicRadioGroup';

import './placesPanel.css';
import BasicInput from '../../inputs/basicInput/basicInput';

import { useInvoiceContext } from '../../../routes/createInvoice/createInvoiceContext';
import { useEffect } from 'react';
import DoublePanel from '../doublePanel/doublePanel';
import { parse } from 'date-fns';
import { shouldApplyEAEULogic, getEAEUDefaultValues, isPaymentOnReceiptAllowed } from '../../../utils/eaeuHelper';
import EAEUWarningModal from '../../eaeuWarningModal/eaeuWarningModal';
import { getCurrencySymbol } from '../../../utils/currencyHelper';
import { useTranslation } from 'react-i18next';

const CARET_SVG =
    <svg width="14" height="9" viewBox="0 0 14 9" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M0.298162 8.13654C-0.0659236 7.78507 -0.0659236 7.21522 0.298163 6.86375L6.51351 0.863751C6.8776 0.512278 7.4679 0.512278 7.83198 0.863751L13.702 6.53042C14.0661 6.88189 14.0661 7.45174 13.702 7.80321C13.3379 8.15468 12.7476 8.15468 12.3836 7.80321L7.17275 2.77294L1.61664 8.13654C1.25255 8.48801 0.66225 8.48801 0.298162 8.13654Z" fill="#17C653"/>
    </svg>


const PLACE_SVG =
    <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M17.5 14.3515V6.64841C17.4994 6.53714 17.4695 6.428 17.4132 6.33199C17.357 6.23597 17.2764 6.15648 17.1797 6.10154L10.3047 2.23435C10.2121 2.18087 10.107 2.15271 10 2.15271C9.89303 2.15271 9.78795 2.18087 9.69531 2.23435L2.82031 6.10154C2.72356 6.15648 2.643 6.23597 2.58676 6.33199C2.53052 6.428 2.5006 6.53714 2.5 6.64841V14.3515C2.5006 14.4628 2.53052 14.572 2.58676 14.668C2.643 14.764 2.72356 14.8435 2.82031 14.8984L9.69531 18.7656C9.78795 18.8191 9.89303 18.8472 10 18.8472C10.107 18.8472 10.2121 18.8191 10.3047 18.7656L17.1797 14.8984C17.2764 14.8435 17.357 14.764 17.4132 14.668C17.4695 14.572 17.4994 14.4628 17.5 14.3515V14.3515Z" stroke="url(#paint0_linear_8035_1159)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M13.8281 12.4141V8.35156L6.25 4.17188" stroke="url(#paint1_linear_8035_1159)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M17.4141 6.32812L10.0703 10.5L2.58594 6.32812" stroke="url(#paint2_linear_8035_1159)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M10.0703 10.5L10 18.8438" stroke="url(#paint3_linear_8035_1159)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <defs>
        <linearGradient id="paint0_linear_8035_1159" x1="2.5" y1="10.5" x2="17.5" y2="10.5" gradientUnits="userSpaceOnUse">
        <stop stop-color="#55E5FF"/>
        <stop offset="1" stop-color="#5DFF66"/>
        </linearGradient>
        <linearGradient id="paint1_linear_8035_1159" x1="6.25" y1="8.29297" x2="13.8281" y2="8.29297" gradientUnits="userSpaceOnUse">
        <stop stop-color="#55E5FF"/>
        <stop offset="1" stop-color="#5DFF66"/>
        </linearGradient>
        <linearGradient id="paint2_linear_8035_1159" x1="2.58594" y1="8.41406" x2="17.4141" y2="8.41406" gradientUnits="userSpaceOnUse">
        <stop stop-color="#55E5FF"/>
        <stop offset="1" stop-color="#5DFF66"/>
        </linearGradient>
        <linearGradient id="paint3_linear_8035_1159" x1="10" y1="14.6719" x2="10.0703" y2="14.6719" gradientUnits="userSpaceOnUse">
        <stop stop-color="#55E5FF"/>
        <stop offset="1" stop-color="#5DFF66"/>
        </linearGradient>
        </defs>
    </svg>

const COPY_SVG =
    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M3.9999 10.1L2.3999 10.1C1.95807 10.1 1.5999 9.74185 1.5999 9.30002L1.5999 4.10002C1.5999 2.99546 2.49534 2.10002 3.59991 2.10002L8.7999 2.10003C9.24173 2.10003 9.5999 2.4582 9.5999 2.90003L9.5999 4.50003M7.9999 14.9L12.7999 14.9C13.6836 14.9 14.3999 14.1837 14.3999 13.3L14.3999 8.50003C14.3999 7.61637 13.6836 6.90003 12.7999 6.90003L7.9999 6.90002C7.11625 6.90002 6.3999 7.61637 6.3999 8.50002L6.3999 13.3C6.3999 14.1837 7.11625 14.9 7.9999 14.9Z" stroke="#17C653" stroke-width="2" stroke-linecap="round"/>
    </svg>

const MINUS_SVG = 
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M3.80005 12C3.80005 11.4477 4.24776 11 4.80005 11L19.2 11C19.7523 11 20.2001 11.4477 20.2001 12C20.2001 12.5523 19.7523 13 19.2 13L4.80005 13C4.24776 13 3.80005 12.5523 3.80005 12Z" fill="#17C653"/>
    </svg>

const PLUS_SVG =
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9.00005 1.80005L9.00005 16.2M16.2 9.00005L1.80005 9.00005" stroke="#17C653" stroke-width="2" stroke-linecap="round"/>
    </svg>

const getVatValues = (t) => [
    { label: t("no_vat"), value: -1 },
    { label: "0%", value: 0 },
    { label: "10%", value: 10 },
    { label: "12%", value: 12 },
    { label: "20%", value: 20 },
]

function sanitizeInput(value) {
    return value.replace(/[^0-9.,]/g, '');
  }
  
  function fixDecimal(value) {
    let result = '';
    let decimalUsed = false;
  
    for (let i = 0; i < value.length; i++) {
      const ch = value[i];
      if (ch === '.' || ch === ',') {
        if (!decimalUsed) {
          // First decimal separator becomes '.'
          decimalUsed = true;
          result += '.';
        }
        // Skip any additional decimal separators
      } else {
        result += ch;
      }
    }
  
    // If the result starts with a decimal point, prepend a '0'
    if (result.startsWith('.')) {
      result = '0' + result;
    }
    
    return result;
  }
  
  /**
   * A "fully typed" float must:
   *   - Not be empty
   *   - Contain digits
   *   - Optionally have one decimal point
   *   - Not end in a decimal point
   * Examples of "fully typed": "5", "5.0", "123.456", "0.3"
   * Examples of partial: "5.", "", ".5" (now becomes "0.5" after fixDecimal)
   */
  function isFullyTypedFloat(value) {
    if (!value) return false;
    if (value.endsWith('.')) return false; // trailing decimal -> partial
    // Must match digits, optional decimal, digits
    return /^\d+(\.\d+)?$/.test(value);
  }
  
  /**
   * Main function:
   *   - Remove invalid chars
   *   - Normalize decimal separators
   *   - If fully typed float, parse & return as number
   *   - Otherwise return the (cleaned) string so the user can continue typing
   */
  function getFloatValue(value) {
    // 1. Clean any invalid characters
    let cleaned = sanitizeInput(value);
  
    // 2. Normalize decimal separators to a single '.'
    cleaned = fixDecimal(cleaned);
  
    // 3. If it's a fully typed float, parse it
    if (isFullyTypedFloat(cleaned)) {
      const num = parseFloat(cleaned);
      // If you want to disallow negatives or zero, adjust this condition:
      return num > 0 ? num : 0;
    }
  
    // 4. Partial input => return the (cleaned) string so the user can keep typing
    return cleaned;
  }

function PlaceHeader({place, error}) {
    const { t } = useTranslation('basic');
    const { invoiceData, setInvoiceData } = useInvoiceContext();
    const calculated_weight = place.weight || place.goods.reduce((sum, good) => sum + good.weight * good.count, 0);

    return (
        <div className={`placeHeader ${error ? 'error' : ''}`}>
            <div className="placeHeaderLeft">
                <Icon as={() => PLACE_SVG} style={{ width: '1rem' }} />
                <span className="placeInfo">
                    <span className="placeNumber paragraph-16M">{t("place_number")}{place.number}</span>
                    <span className="placeWeight paragraph-12R">
                        {t("calculated_weight_kg")} <span>{calculated_weight || 0}кг</span>
                    </span>
                </span>
            </div>
            <IconButton icon={COPY_SVG} size='xs'
                onClick={(e) => {
                    e.stopPropagation();
                    setInvoiceData(oldData => {
                        // Create new place with existing data
                        const newData = {...oldData};

                        let goods_deep_copy = place.goods.map(good => ({...good}));
                        let goods_copy = [...goods_deep_copy];
                        newData.places.push({...place, goods: goods_copy});

                        return newData
                    })
                }}/>
        </div>
    )
}

function PlaceBody({place, isCalculate, userInfo}) {
    const { t } = useTranslation('basic');
    const { invoiceData, setInvoiceData } = useInvoiceContext();
    const currencySymbol = getCurrencySymbol(invoiceData?.user_info);
    const isDisabled = !invoiceData.contract_number;

    return (
        <div className="placeBodyWrapper">
            <div className="placeBody">
                <div className="placeInputsGroup">
                    <BasicInput placeholder={t("height_cm")}
                        flexible
                        type="number"
                        disabled={isDisabled}
                        error={invoiceData.errors?.[`places.${place.number - 1}`]?.width}
                        onChange={(value, e) => {
                            value = value.replace(/[^0-9.,]/g, '');

                            if (!value) {
                                e.target.value = null;
                            }

                            setInvoiceData(oldData => {
                                const newData = {...oldData};
                                newData.places[place.number - 1].height = parseInt(value) || null;
                                return newData
                            });
                        }}
                        value={place.height}/>
                    <BasicInput placeholder={t("length_cm")}
                        flexible
                        disabled={isDisabled}
                        error={invoiceData.errors?.[`places.${place.number - 1}`]?.length}
                        onChange={(value, e) => {
                            value = value.replace(/[^0-9.,]/g, '');

                            if (!value) {
                                e.target.value = null;
                            }

                            setInvoiceData(oldData => {
                                const newData = {...oldData};
                                newData.places[place.number - 1].length = parseInt(value) || null;
                                return newData
                            })
                        }}
                        value={place.length}/>
                    <BasicInput placeholder={t("width_cm")}
                        flexible
                        disabled={isDisabled}
                        error={invoiceData.errors?.[`places.${place.number - 1}`]?.width}
                        onChange={(value, e) => {
                            value = value.replace(/[^0-9.,]/g, '');

                            if (!value) {
                                e.target.value = null;
                            }
                            
                            setInvoiceData(oldData => {
                                const newData = {...oldData};
                                newData.places[place.number - 1].width = parseInt(value) || null;
                                return newData
                            })
                        }}
                        value={place.width}/>
                </div>
                { 
                    isCalculate &&
                    <BasicInput placeholder={t("weight_kg")}
                        flexible
                        disabled={isDisabled}
                        error={invoiceData.errors?.[`places.${place.number - 1}`]?.weight}
                        onChange={(value) => {
                            setInvoiceData(oldData => {
                                const newData = {...oldData};
                                newData.places[place.number - 1].weight = getFloatValue(value);
                                return newData
                            })
                        }}
                    value={place.weight}/>
                }
                {
                    userInfo?.contract_type === 3 && (
                        <>
                            <BasicInput placeholder={t("attachment_description")}
                                flexible
                                disabled={isDisabled}
                                onChange={(value) => {
                                    setInvoiceData(oldData => {
                                        const newData = {...oldData};
                                        if (!newData.places[place.number - 1].goods) {
                                            newData.places[place.number - 1].goods = [{}];
                                        }
                                        newData.places[place.number - 1].goods[0].name = value;
                                        return newData
                                    })
                                }}
                                value={place.goods?.[0]?.name}/>
                            <BasicInput placeholder={t("insurance_per_item")}
                                flexible
                                disabled={isDisabled}
                                addonAfter={currencySymbol}
                                onChange={(value) => {
                                    setInvoiceData(oldData => {
                                        const newData = {...oldData};
                                        if (!newData.places[place.number - 1].goods) {
                                            newData.places[place.number - 1].goods = [{}];
                                        }
                                        newData.places[place.number - 1].goods[0].insurance = getFloatValue(value);
                                        return newData
                                    })
                                }}
                                value={place.goods?.[0]?.insurance}/>
                            <div style={{display: 'flex', gap: '1rem'}}>
                                <BasicInput placeholder={t("weight_kg")}
                                    flexible
                                    disabled={isDisabled}
                                    onChange={(value) => {
                                        setInvoiceData(oldData => {
                                            const newData = {...oldData};
                                            if (!newData.places[place.number - 1].goods) {
                                                newData.places[place.number - 1].goods = [{}];
                                            }
                                            newData.places[place.number - 1].goods[0].weight = getFloatValue(value);
                                            
                                            // update place weight
                                            let calculated_weight = newData.places[place.number - 1].goods.reduce((sum, good) => sum + good.weight * good.count, 0);
                                            newData.places[place.number - 1].weight = calculated_weight;

                                            return newData
                                        })
                                    }}
                                    value={place.goods?.[0]?.weight}/>
                                <BasicNumberInput label={t("quantity")}
                                    disabled={isDisabled}
                                    onChange={(value) => {
                                        if (value <= 0) value = 1;

                                        setInvoiceData(oldData => {
                                            const newData = {...oldData};
                                            if (!newData.places[place.number - 1].goods) {
                                                newData.places[place.number - 1].goods = [{}];
                                            }
                                            newData.places[place.number - 1].goods[0].count = Math.max(parseInt(value) || 0, 0);

                                            let calculated_weight = newData.places[place.number - 1].goods.reduce((sum, good) => sum + good.weight * good.count, 0);
                                            newData.places[place.number - 1].weight = calculated_weight;

                                            return newData
                                        })
                                    }}
                                    value={place.goods?.[0]?.count}/>
                            </div>
                        </>
                    )
                }
                {
                    invoiceData.places.length > 1 &&
                    <BasicButton
                        disabled={isDisabled}
                        style={{
                                textAlign: "left"
                            }}
                        onClick={() => {
                            setInvoiceData(oldData => {
                                const newData = {...oldData};
                                newData.places.splice(place.number - 1, 1);
                                return newData
                            })
                        }}
                        width='fit-content' color="red" orient="flex-start"
                    >{t("delete_place")}</BasicButton>
                }
            </div>
            { !isCalculate && userInfo?.contract_type !== 3 ?
                <>
                <div className='placesGoodsLabel paragraph-14M' style={{
                    marginTop: '0.5rem'
                }}>
                    <span>
                        {t("goods")}
                    </span>
                    <IconButton icon={PLUS_SVG} size='xs'
                        disabled={isDisabled}
                        onClick={() => {
                            setInvoiceData(oldData => {
                                const newData = {...oldData};
                                const isEAEU = shouldApplyEAEULogic(invoiceData.cityFromCountryCode, invoiceData.cityToCountryCode);
                                const defaults = getEAEUDefaultValues(t);
                                
                                const newGood = {
                                    name: isEAEU ? defaults.goodsName : t('default_goods_name'), 
                                    weight: null, 
                                    count: 1, 
                                    price: null, 
                                    insurance: null, 
                                    article: isEAEU ? defaults.article : '', 
                                    vat: invoiceData.vat
                                };
                                
                                newData.places[place.number - 1].goods.push(newGood);
                                return newData
                            })
                        }}/>
                </div>
                {place.goods.map((good, index) => <PlaceGoods error={
                    invoiceData.errors?.[`places.${place.number - 1}`]?.[`goods.${index}`] ?
                    Object.keys(invoiceData.errors?.[`places.${place.number - 1}`]?.[`goods.${index}`]).length > 0 : false
                } place_index={place.number - 1} good={good} index={index} key={index} />)}
                </> : null
            }
        </div>
    )
}

function PlaceGoods({place_index, good, index, error}) {
    const { t } = useTranslation('basic');
    const { invoiceData, setInvoiceData } = useInvoiceContext();
    const currencySymbol = getCurrencySymbol(invoiceData?.user_info);
    const isDisabled = !invoiceData.contract_number;
    
    const [showEAEUWarning, setShowEAEUWarning] = useState(false);
    const [fieldChanged, setFieldChanged] = useState({
        article: false,
        name: false
    });

    useEffect(() => {
        console.log("s")
        setInvoiceData(oldData => {
            const newData = {...oldData};
            newData.places[place_index].goods[index].vat = invoiceData.vat;
            newData.places[place_index].goods[index].vat_sum = invoiceData.vat <= 0 ? null :
                                    Math.round( (good.price - ( good.price / ( (invoiceData.vat / 100.0 + 1) || ((invoiceData.vat / 100.0 + 1) > 1 ? (invoiceData.vat / 100.0 + 1) - 1 : (invoiceData.vat / 100.0 + 1) )) ) ) * 100) / 100
                                
            return newData
        })
    }, [invoiceData.vat])

    // Reset field changed flags when entering EAEU mode
    // Note: The actual goods values are set by the effect in 1_invoiceMain.jsx
    useEffect(() => {
        const isEAEU = shouldApplyEAEULogic(invoiceData.cityFromCountryCode, invoiceData.cityToCountryCode);
        
        // Reset field changed flags when entering EAEU mode (including after voice input)
        if (isEAEU && !invoiceData._isApplyingTemplate && (!invoiceData._isVoiceInput || !invoiceData._needsEAEUCheck)) {
            setFieldChanged({ article: false, name: false });
        }
    }, [invoiceData.cityFrom, invoiceData.cityTo, invoiceData.cityFromCountryCode, invoiceData.cityToCountryCode, invoiceData._isVoiceInput, invoiceData._needsEAEUCheck])

    return (
        <>
        <EAEUWarningModal 
            open={showEAEUWarning} 
            onClose={() => setShowEAEUWarning(false)} 
        />
        <PanelGroup accordion className={`placeGoodsWrapper ${error ? 'error' : ''}`}>
            <Panel caretAs={() => <span className="panelCaret">{CARET_SVG}</span>} header={
                <div className="placeGoodsHeader">
                    <span className="placeGoodsName paragraph-16M">{good.name || t("no_name")}</span>
                    <span className="placeGoodsCount paragraph-12R">{good.count} {t("pcs")}</span>
                </div>
            } defaultExpanded={index === 0}>
                <div className="placeGoodsBody">
                    <BasicInput placeholder={t("article")}
                        flexible
                        disabled={isDisabled}
                        error={invoiceData.errors?.[`places.${place_index}`]?.[`goods.${index}`]?.article}
                        onFocus={() => {
                            const isEAEU = shouldApplyEAEULogic(invoiceData.cityFromCountryCode, invoiceData.cityToCountryCode);
                            
                            // Show warning on focus if in EAEU mode and field hasn't been changed by user yet
                            if (isEAEU && !fieldChanged.article && !invoiceData._eaeuWarningShown) {
                                setShowEAEUWarning(true);
                                setInvoiceData(oldData => ({ ...oldData, _eaeuWarningShown: true }));
                            }
                        }}
                        onChange={(value) => {
                            const isEAEU = shouldApplyEAEULogic(invoiceData.cityFromCountryCode, invoiceData.cityToCountryCode);
                            const defaults = getEAEUDefaultValues(t);
                            
                            // Show warning if user tries to change article in EAEU mode and hasn't changed it before
                            if (isEAEU && value !== defaults.article && !fieldChanged.article && !invoiceData._eaeuWarningShown) {
                                setShowEAEUWarning(true);
                                setInvoiceData(oldData => ({ ...oldData, _eaeuWarningShown: true }));
                                setFieldChanged(prev => ({ ...prev, article: true }));
                            }
                            
                            setInvoiceData(oldData => {
                                const newData = {...oldData};
                                newData.places[place_index].goods[index].article = value;
                                return newData
                            })
                        }}
                        value={good.article}/>
                    <BasicInput placeholder={t("goods_name")}
                        flexible
                        disabled={isDisabled}
                        error={invoiceData.errors?.[`places.${place_index}`]?.[`goods.${index}`]?.name}
                        onFocus={() => {
                            const isEAEU = shouldApplyEAEULogic(invoiceData.cityFromCountryCode, invoiceData.cityToCountryCode);
                            
                            // Show warning on focus if in EAEU mode and field hasn't been changed by user yet
                            if (isEAEU && !fieldChanged.name && !invoiceData._eaeuWarningShown) {
                                setShowEAEUWarning(true);
                                setInvoiceData(oldData => ({ ...oldData, _eaeuWarningShown: true }));
                            }
                        }}
                        onChange={(value) => {
                            const isEAEU = shouldApplyEAEULogic(invoiceData.cityFromCountryCode, invoiceData.cityToCountryCode);
                            const defaults = getEAEUDefaultValues(t);
                            
                            // Show warning if user tries to change goods name in EAEU mode and hasn't changed it before
                            if (isEAEU && value !== defaults.goodsName && !fieldChanged.name && !invoiceData._eaeuWarningShown) {
                                setShowEAEUWarning(true);
                                setInvoiceData(oldData => ({ ...oldData, _eaeuWarningShown: true }));
                                setFieldChanged(prev => ({ ...prev, name: true }));
                            }
                            
                            setInvoiceData(oldData => {
                                const newData = {...oldData};
                                newData.places[place_index].goods[index].name = value;
                                return newData
                            })
                        }}
                        value={good.name}/>
                    <BasicInput placeholder={t("insurance_per_item")}
                        flexible
                        disabled={isDisabled}
                        addonAfter={currencySymbol}
                        error={invoiceData.errors?.[`places.${place_index}`]?.[`goods.${index}`]?.insurance}
                        onChange={(value) => {
                            setInvoiceData(oldData => {
                                const newData = {...oldData};
                                newData.places[place_index].goods[index].insurance = getFloatValue(value);
                                newData.places[place_index].goods[index].vat_sum = good.vat <= 0 ? null :
                                    Math.round( (good.price - ( good.price / ( (good.vat / 100.0 + 1) || ((good.vat / 100.0 + 1) > 1 ? (good.vat / 100.0 + 1) - 1 : (good.vat / 100.0 + 1) )) ) ) * 100) / 100
                                
                                return newData
                            })
                        }}
                        value={good.insurance}/>
                    {  
                    invoiceData.payment_on_receipt && isPaymentOnReceiptAllowed(invoiceData.cityFromCountryCode, invoiceData.cityToCountryCode, invoiceData.user_info?.is_kz) &&
                    <BasicInput placeholder={t("payment_per_item")}
                        flexible
                        disabled={isDisabled}
                        addonAfter={currencySymbol}
                        error={invoiceData.errors?.[`places.${place_index}`]?.[`goods.${index}`]?.price}
                        onChange={(value) => {
                            setInvoiceData(oldData => {
                                const newData = {...oldData};
                                newData.places[place_index].goods[index].price = getFloatValue(value);
                                newData.places[place_index].goods[index].vat_sum = good.vat <= 0 ? 0 :
                                    Math.round( (good.price - ( good.price / ( (good.vat / 100.0 + 1) || ((good.vat / 100.0 + 1) > 1 ? (good.vat / 100.0 + 1) - 1 : (good.vat / 100.0 + 1) )) ) ) * 100) / 100
                                return newData
                            })
                        }}
                        value={good.price}/>
                    }
                    <div style={{display: 'flex', gap: '1rem'}}>
                        <BasicInput placeholder={t("weight_kg")}
                            flexible
                            disabled={isDisabled}
                            error={invoiceData.errors?.[`places.${place_index}`]?.[`goods.${index}`]?.weight}
                            onChange={(value) => {
                                setInvoiceData(oldData => {
                                    const newData = {...oldData};
                                    newData.places[place_index].goods[index].weight = getFloatValue(value);

                                    // update place weight
                                    let calculated_weight = newData.places[place_index].goods.reduce((sum, good) => sum + good.weight * good.count, 0);
                                    newData.places[place_index].weight = calculated_weight;

                                    return newData
                                })
                            }}
                            value={good.weight}/>
                        <BasicNumberInput label={t("quantity")}
                            disabled={isDisabled}
                            error={invoiceData.errors?.[`places.${place_index}`]?.[`goods.${index}`]?.count}
                            onChange={(value) => {
                                if (value <= 0) value = 1;

                                setInvoiceData(oldData => {
                                    const newData = {...oldData};
                                    newData.places[place_index].goods[index].count = Math.max(parseInt(value) || 0, 0);

                                    let calculated_weight = newData.places[place_index].goods.reduce((sum, good) => sum + good.weight * good.count, 0);
                                    newData.places[place_index].weight = calculated_weight;

                                    return newData
                                })
                            }}
                            value={good.count}/>
                    </div>
                    <BasicInput placeholder={t("vat_sum_label")}
                        disabled
                        flexible
                        value={ good.vat_sum }/>
                    {
                    invoiceData.places[place_index].goods.length > 1 &&
                    <BasicButton width='fit-content' color="red"
                        disabled={isDisabled}
                        style={{
                            marginTop: "0.5rem"
                        }}
                        onClick={() => {
                            setInvoiceData(oldData => {
                                const newData = {...oldData};
                                newData.places[place_index].goods.splice(index, 1);
                                return newData
                            })
                        }}
                        orient="flex-start">{t("delete_goods")}</BasicButton>
                    }
                </div>
            </Panel>
        </PanelGroup>
        </>
    )
}

export default function PlacesPanel({isCalculate, userInfo}) {
    const { t } = useTranslation('basic');
    const { invoiceData, setInvoiceData } = useInvoiceContext();
    const [ toAdd, setToAdd ] = useState(1);
    const isDisabled = !invoiceData.contract_number;

    const hasErrors = (placeIndex) => {
        const placeErrors = invoiceData.errors?.[`places.${placeIndex}`];
        if (!placeErrors) return false;

        const { goods, ...rest } = placeErrors;
        const hasDirectErrors = Object.keys(rest).length > 0;

        const hasGoodsErrors = Object.values(goods || {}).some(
            goodErr => Object.keys(goodErr || {}).length > 0
        );

        return hasDirectErrors || hasGoodsErrors;
    };

    return (
        <div className='placeWrapper'>
            <PanelGroup accordion bordered>
                {invoiceData.places.map((place, index) => (
                    <Panel className={hasErrors(index) ? 'placePanel error' : 'placePanel'} bodyFill caretAs={() => <></>} header={<PlaceHeader place={{...place, number: index + 1}} />} key={index} defaultExpanded={index === 0}>
                        <PlaceBody isCalculate={isCalculate} place={{...place, number: index + 1}} userInfo={userInfo} />
                    </Panel>
                ))}
            </PanelGroup>
            <div className='placeAddPanel'>
                <div className='basicNumberInputWrapper'>
                    <IconButton className='placeButton' icon={MINUS_SVG} size='xs' disabled={isDisabled} onClick={() => {
                        setToAdd(toAdd => Math.max(0, (toAdd || 0) - 1));
                    }} />
                    <input onChange={(e) => {
                        setToAdd(parseInt(e.target.value) || 1);
                    }} disabled={isDisabled} className='basicNumberInput placeButton' placeholder='' type='text' value={toAdd} />
                    <IconButton className='placeButton' icon={PLUS_SVG} size='xs' disabled={isDisabled} onClick={() => {
                        setToAdd(toAdd => Math.max(0, (toAdd || 0) + 1));
                    }} />
                </div>
                <BasicButton disabled={isDisabled} onClick={() => {
                    setInvoiceData(oldData => {
                        const newData = {...oldData};
                        const isEAEU = shouldApplyEAEULogic(invoiceData.cityFromCountryCode, invoiceData.cityToCountryCode);
                        const defaults = getEAEUDefaultValues(t);
                        
                        for (let i = 0; i < toAdd; i++) {
                            newData.places.push({height: 0, length: 0, width: 0, goods: [
                                {
                                    name: isEAEU ? defaults.goodsName : t('default_goods_name'),
                                    weight: null,
                                    count: 1,
                                    article: isEAEU ? defaults.article : "",
                                    price: null,
                                    insurance: null,
                                    vat: -1  
                                }
                            ]});
                        }
                        return newData
                    })

                    setToAdd(1);
                }} color="green" className='placeButton'>{t("add_place")}</BasicButton>
            </div>
        </div>
    )
}